import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import VorteileSection from '../components/VorteileSection';
import VerbindungSection from '../components/VerbindungSection';
import VeranstaltungenSection from '../components/VeranstaltungenSection';
import HausSection from '../components/HausSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const HomePage = () => {
  useEffect(() => {
    // Wenn URL einen Hash hat, scrolle zu dem Element, sonst nach oben
    if (window.location.hash) {
      setTimeout(() => {
        const element = document.querySelector(window.location.hash);
        if (element) {
          // Berechne die Position mit einem Offset für bessere Sichtbarkeit
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - 100; // 100px Offset von oben
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 300); // Etwas länger warten bis alle Komponenten geladen sind
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <>
      <Navbar />
      <HeroSection />
      <AboutSection />
      <VorteileSection />
      <VerbindungSection />
      <VeranstaltungenSection />
      <HausSection />
      <ContactSection />
      <Footer />
    </>
  );
};

export default HomePage;